import { useSyncExternalStore } from 'react';

import { projectStateAdapter } from '../state/project-state/project-state-adapter';

/**
 * React hook to read the current project snapshot from the project state adapter.
 * Re-renders when the snapshot changes (e.g. when navigating between projects
 * or when project state is updated by ProjectStateAdapterBridge).
 */
export function useProjectSnapshot() {
  return useSyncExternalStore(
    projectStateAdapter.subscribe.bind(projectStateAdapter),
    projectStateAdapter.getSnapshot.bind(projectStateAdapter),
    projectStateAdapter.getSnapshot.bind(projectStateAdapter),
  );
}
